import { EditParam } from '../../../Modals/EditParam'
import useStyles from './useStyles'

function TableItem({ item, parameterData, refresh }) {
  const classes = useStyles()
  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemName}>{item.app_parameter_desc}</td>
        <td className={classes.itemValue}>
          Númerico
        </td>

        <td className={classes.itemValue}>
          {parameterData?.parameter_num_value ? parseFloat(parameterData.parameter_num_value) : "No configurado"}
        </td>

        <td className={classes.itemKebab}>
          <EditParam param={item} refresh={refresh} parameterData={parameterData} />
        </td>
      </tr>
    </>
  )
}

export default TableItem
